import { publicIpv4 } from "public-ip";
import axios from "axios";
import { GeoInfo } from "@/types";

/**
 * Gets the geographical information based on the public IP address.
 * @returns {Promise<GeoInfo|null>} The geographical information or null in case of an error.
 */
export const getGeoInfo = async (): Promise<GeoInfo | null> => {
  return publicIpv4().then((ip): Promise<GeoInfo | null> | GeoInfo | null => {
    const ipApiKey = `ipApiKey-${ip}`;
    const cached = localStorage.getItem(ipApiKey);

    if (cached === null) {
      return axios
        .get<GeoInfo>(`https://ipapi.co/${ip}/json`)
        .then((res): GeoInfo => {
          const data = res.data;
          localStorage.setItem(ipApiKey, JSON.stringify(data));
          return data;
        })
        .catch((): null => {
          // TODO: Handle error
          return null;
        });
    } else {
      return JSON.parse(cached) as GeoInfo;
    }
  });
};
